export default __webpack_public_path__ + "static/media/PresentorPast.bcc26cf5.svg";